// Class
import { SmartTagBase } from './smartTagBase';
// Model
import { SmartTagModel } from './smartTag.model';

export class SmartTagSpaceModel extends SmartTagModel {
	spaceCount?: number;

	constructor() {
		super();

		this.spaceCount = null;
	}
}

export class SmartTagSpace extends SmartTagBase {

	/**
	 * Renderer
	 * @param data SmartTagUpdateModel
	 */
	public render(data: SmartTagSpaceModel, version?: string): string {
		this.getData(data);

		return this.getOutputData(version || 'v1');
	}

	private getData(data: SmartTagSpaceModel): void{
		const title = data.title || data.subCategory || '';
		const spaceCount = data.spaceCount || '';
		const description = data.description?.trim() || '';

		if (title !== '') {
			this.title = `<span title="${title}">Type: ${title}</span>`;
		}

		if (spaceCount !== '') {
			this.addText(`<span title="${spaceCount}">Space Count: ${spaceCount}</span>`);
		}

		if (description !== '') {
			this.addText(`<span title="${description}">Description: ${description}</span>`);
		}
	}
}
